import { OtsComponentFull, OtsComponentPartLiteDto, PartLiteTypes, StandardPartTypes } from '@luminovo/api-contracts';

export function hasMultipleOrGenericMatches(ipn: OtsComponentFull): boolean {
    return ipn.matches.length > 1 || ipn.matches.some((match) => match.part.type === StandardPartTypes.Generic);
}

export function hasMultipleOrGenericMatchesLite(ipn: OtsComponentPartLiteDto): boolean {
    return ipn.matches.length > 1 || ipn.matches.some((match) => match.kind === PartLiteTypes.Generic);
}
